import { useQuery } from "@tanstack/react-query";

import { api } from "@/api/api";
import type { HotelSearchFormValues } from "@/features/hotels/utils/hotelsValidation";
import type {
  InitiateHotelsSearchBodyInputDto,
  InitiateHotelsSearchOutputDto,
} from "@/types/codegen";
import { getDateString } from "@/utils/dates";

export const searchHotelDataMapper = (
  searchData: HotelSearchFormValues,
): InitiateHotelsSearchBodyInputDto => {
  return {
    cityId: searchData.destination!.id,
    checkIn: getDateString(searchData.dates.checkIn),
    checkOut: getDateString(searchData.dates.checkOut),
    occupancy: {
      rooms: searchData.rooms.map(({ adults, childrenAges }) => ({
        adults,
        childrenAges: childrenAges.map((age) => Number(age)),
      })),
    },
  };
};

export const useHotelSearchTokens = (
  payload: InitiateHotelsSearchBodyInputDto | null,
) =>
  useQuery({
    queryKey: ["hotels", "search", "tokens", payload] as const,
    queryFn: ({ signal }) =>
      api.post<InitiateHotelsSearchOutputDto>("/hotels/search", payload, {
        signal,
      }),
    select: (response) => response.data.data,
    enabled: Boolean(payload),
    gcTime: 0,
  });
